// This publisher should not see its own account balance in the dashboard.
const HIDDEN_BALANCE_EMAIL = 'mignews@c14.co.il'

export default function hideAccountBalance(account, viewer) {
  if (!account || !viewer) return false

  const accountEmail = String(account.email || '').trim().toLowerCase()
  const viewerEmail = String(viewer.email || '').trim().toLowerCase()
  const roles = [viewer.role, ...(Array.isArray(viewer.roles) ? viewer.roles : [])]

  return accountEmail === HIDDEN_BALANCE_EMAIL
    && viewerEmail === HIDDEN_BALANCE_EMAIL
    && !roles.includes('admin')
}
